import React from "react";
import { createPortal } from "react-dom";
import "./OrderTicket.css";

const formatDateTime = (value) => {
  if (!value) return "-";
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleString();
};

// Printable kitchen/cashier ticket for a single order. Rendered via a portal
// directly under <body> (a sibling of #root) so `@media print` can hide the
// entire app (#root) without hiding this ticket - see OrderTicket.css.
const OrderTicket = ({ order, restaurantName }) => {
  if (!order) return null;

  const items = order.items || [];

  return createPortal(
    <div className="printable-ticket">
      <h2 className="order-ticket-restaurant">
        {restaurantName || order.restaurant_name || "Restaurant"}
      </h2>

      <div className="order-ticket-row">
        <span>Order #</span>
        <span>{order.order_id}</span>
      </div>
      <div className="order-ticket-row">
        <span>{order.table_number ? "Table" : "Order Type"}</span>
        <span>{order.table_number ? `Table ${order.table_number}` : "Pickup"}</span>
      </div>
      <div className="order-ticket-row">
        <span>Customer</span>
        <span>{order.customer_name || "-"}</span>
      </div>
      <div className="order-ticket-row">
        <span>Phone</span>
        <span>{order.phone_number || "-"}</span>
      </div>
      <div className="order-ticket-row">
        <span>Order Time</span>
        <span>{formatDateTime(order.created_at)}</span>
      </div>
      <div className="order-ticket-row">
        <span>Status</span>
        <span>{order.status}</span>
      </div>

      <hr />

      <table className="order-ticket-items">
        <thead>
          <tr>
            <th>Item</th>
            <th>Qty</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.menu_item_id}>
              <td>{item.product_name}</td>
              <td>{item.quantity}</td>
              <td>${Number(item.price).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr />

      {order.other_order_details && (
        <div className="order-ticket-notes">
          <strong>Notes:</strong> {order.other_order_details}
        </div>
      )}

      <div className="order-ticket-total">
        <span>Total</span>
        <span>${Number(order.total_amount).toFixed(2)}</span>
      </div>
    </div>,
    document.body
  );
};

export default OrderTicket;
